function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_1_",
  x1: 57.581,
  x2: 57.581,
  y1: 103.831,
  y2: 14.615,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#FFCD05"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFDE8A"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SVGID_1_)",
  stroke: "#FFCD05",
  strokeMiterlimit: 10,
  d: "M102.189 92.28c0 6.379-5.17 11.551-11.551 11.551H24.524c-6.379 0-11.551-5.172-11.551-11.551V26.166c0-6.379 5.171-11.551 11.551-11.551h66.115c6.381 0 11.551 5.171 11.551 11.551V92.28z"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 57.582,
  cy: 59.223,
  r: 36,
  fill: "#FFF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M57.581 23.222c-19.883 0-36 16.117-36 36 0 19.882 16.117 36.001 36 36.001 19.881 0 36-16.119 36-36.001.001-19.883-16.119-36-36-36zm0 65.001c-15.991 0-29-13.01-29-29.001s13.009-29 29-29 29 13.009 29 29-13.009 29.001-29 29.001z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M57.582 37.376c-12.066 0-21.847 9.78-21.847 21.847 0 12.064 9.78 21.846 21.847 21.846 12.064 0 21.846-9.781 21.846-21.846 0-12.066-9.782-21.847-21.846-21.847zm8.459 34.083l-.035-.027a14.755 14.755 0 01-8.424 2.637c-3.114 0-6.005-.969-8.395-2.613l-.005.004.002-.006c-3.891-2.68-6.449-7.16-6.449-12.23 0-8.125 6.561-14.737 14.662-14.838l.006-.02.006.02c.058 0 .114-.009.173-.009 8.186 0 14.846 6.659 14.846 14.847 0 5.049-2.539 9.51-6.402 12.193l.015.042z"
});

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M54.958 55.25h3.838c.596 0 .77-.373.387-.83l-5.242-6.262c-.382-.456-1.009-.456-1.39 0l-5.243 6.262c-.383.457-.208.83.388.83h3.838v7.797h3.422V55.25z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.205 63.195h-3.838c-.595 0-.77.374-.387.832l5.241 6.26c.383.457 1.009.457 1.392 0l5.242-6.26c.382-.458.207-.832-.389-.832h-3.84v-7.706h-3.421v7.706z"
}));

var SvgDouaneLogo = function SvgDouaneLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114.754,
    height: 118.443,
    x: 0,
    y: 0,
    viewBox: "0 0 114.754 118.443",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDouaneLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DouaneLogo.0d0fe8d7.svg";
export { ForwardRef as ReactComponent };